import { createContext, useEffect, useRef, useState } from "react";
import { ConfigProvider } from "antd";
import AppRoutes from "./Routes/AppRoutes";
import "./App.css";
import updateUserStates, {
  getRefreshToken,
  handleLogout,
} from "./Utlis/UpdateUsersState";
import { refresh } from "./API/auth";
import { decryptText, encryptText } from "./Utlis/Encryption";
import { ClipLoader } from "react-spinners";

const UserContext = createContext();

function App() {
  const [userData, setUserData] = useState({
    id: "",
    email: "",
    name: "",
    role: "",
    verified: "",
    paid: "",
  });
  const [userToken, setUserToken] = useState({ access: "", refresh: "" });
  const [loading, setLoading] = useState(true);
  const hasInitialized = useRef(false);

  const refreshAccessToken = async (token) => {
    try {
      let myRefreshToken = token?.refresh;

      if (!myRefreshToken) {
        myRefreshToken = getRefreshToken();
      }

      // Call backend
      const res = await refresh(myRefreshToken);

      // Success case
      if (res?.status === 200) {
        const localStorageItems = localStorage;

        if (localStorageItems.length !== 0) {
          Object.keys(localStorageItems).forEach((key) => {
            try {
              if (decryptText(key) === "token") {
                localStorage.removeItem(key);
              }
            } catch (err) {
              console.log("❌ [REFRESH] Error removing token:", err);
            }
          });
        }

        const newTokenObj = {
          access: res?.data?.access,
          refresh: res?.data?.refresh,
        };

        localStorage.setItem(
          encryptText("token"),
          encryptText(JSON.stringify(newTokenObj)),
        );

        updateUserStates(setUserData, setUserToken);

        return newTokenObj.access;
      } else {
        handleLogout(setUserData, setUserToken);
        return null;
      }
    } catch (error) {
      console.log("💥 [REFRESH] Error occurred:", error);
      console.log("📛 [REFRESH] Error response:", error?.response);

      handleLogout(setUserData, setUserToken);
      return null;
    }
  };

  useEffect(() => {
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    const initializeUserState = async () => {
      try {
        const updatedStates = updateUserStates(setUserData, setUserToken);

        if (updatedStates?.token?.access && updatedStates?.token?.refresh) {
          await refreshAccessToken(updatedStates.token);
        }
      } catch (err) {
        console.log("Init error:", err);
      } finally {
        setLoading(false);
      }
    };

    initializeUserState();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        className="loader-container"
      >
        <ClipLoader size={50} color={"#123abc"} loading={loading} />
      </div>
    );
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#4928FD",
        },
      }}
    >
      <UserContext.Provider
        value={{
          userData,
          setUserData,
          userToken,
          setUserToken,
        }}
      >
        <AppRoutes />
      </UserContext.Provider>
    </ConfigProvider>
  );
}

export default App;
export { UserContext };
